export default "__VITE_PUBLIC_ASSET__fa43a077__"